import * as React from 'react';

export type BBOContextData = null | {
    personalizationGroup?: string;
    personalizationType?: string;
};

export const BBOContext = React.createContext<BBOContextData>(null);
